import React, { useState, useEffect } from 'react';
import styles from './PageComponent.module.css';

const PageComponent = ({ pageInfo, onPageChange, pageGroupSize = 5 }) => {
  const [groupStart, setGroupStart] = useState(0); // 현재 보여지는 페이지 그룹 시작 인덱스
  const { pageNumber, totalPages } = pageInfo;



  useEffect(() => {
    // 가운데 기준으로 groupStart 계산
    let newGroupStart = pageNumber - Math.floor(pageGroupSize / 2);

    // 음수 방지
    if (newGroupStart < 0) newGroupStart = 0;

    // 최대값 제한 (totalPages를 벗어나지 않도록)
    if (newGroupStart + pageGroupSize > totalPages) {
      newGroupStart = Math.max(totalPages - pageGroupSize, 0);
    }

    if (newGroupStart !== groupStart) {
      setGroupStart(newGroupStart);
    }
  }, [pageNumber, groupStart, pageGroupSize, totalPages]);



  const renderPaginationButtons = () => {
    const buttons = [];
    const groupEnd = Math.min(groupStart + pageGroupSize, totalPages);

    for (let i = groupStart; i < groupEnd; i++) {
      buttons.push(
        <button
          key={i}
          className={`${styles.pageBtn} ${pageNumber === i ? styles.activePage : ''}`}
          onClick={() => onPageChange(i)}
        >
          {i + 1}
        </button>
      );
    }
    return buttons;
  };

  return (
    <div className={styles.pagination}>

      {/* 이전 페이지 */}
      <button
        disabled={pageNumber === 0}
        onClick={() => onPageChange(pageNumber - 1)}
        className={styles.navBtn}
      >
        &lt;
      </button>

      <div className={styles.pageNumbers}>
        {renderPaginationButtons()}
      </div>

      {/* 다음 페이지 */}
      <button
        disabled={pageNumber >= totalPages - 1}
        onClick={() => onPageChange(pageNumber + 1)}
        className={styles.navBtn}
      >
        &gt;
      </button>

    </div>
  );
};

export default PageComponent;